import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export default defineNuxtPlugin(() => {
  const router = useRouter();

  const lastRoute = ref(router.currentRoute.value);

  router.afterEach((_to, from) => {
    lastRoute.value = from;
  });

  return {
    provide: {
      lastRoute,
    },
  };
});

export type lastRoute = Ref<RouteLocationNormalizedLoadedGeneric>;

interface PluginsInjections {
  $lastRoute: lastRoute;
}

declare module '#app' {
  interface NuxtApp extends PluginsInjections {}
}
